import { SearchParamsOption } from "ky";
import { MAIN_API_ROOT } from "../../app_config";
import createApiClient from "./createApiClient";

export const publicApiClient = createApiClient(MAIN_API_ROOT);

export const publicPost = async <T>(endpoint: string, data: unknown) =>
  await publicApiClient.post(endpoint, { json: data }).json<T>();

export const publicGet = async <T>(
  endpoint: string,
  searchParams?: SearchParamsOption,
) => await publicApiClient.get(endpoint, { searchParams }).json<T>();

// export const privateGet = async <T>(
//   endpoint: string,
//   searchParams: SearchParamsOption,
// ) => await privateApiClient.post(endpoint, { searchParams }).json<T>();
